// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchBar_search__1uGbo","input":"SearchBar_input__35An9","searchButton":"SearchBar_searchButton__1mtZa"};